const statusConfig = {
  aguardando_aprovacao: { label: "Aguardando Aprovação", next: "Aprovação da operação", className: "bg-yellow-500/15 text-yellow-500 border border-yellow-500/20" },
  aguardando_aprovacao_zemo: { label: "Aguardando Aprovação", next: "Aprovação da operação", className: "bg-yellow-500/15 text-yellow-500 border border-yellow-500/20" },
  aguardando_assinatura: { label: "Aguardando Assinatura", next: "Assine o contrato para prosseguir", className: "bg-purple-500/15 text-purple-500 border border-purple-500/20" },
  aguardando_pagamento: { label: "Aguardando Pagamento", next: "Pagamento será processado em breve", className: "bg-blue-500/15 text-blue-500 border border-blue-500/20" },
  liquidado: { label: "Pago", next: null, className: "bg-emerald-500/15 text-emerald-500 border border-emerald-500/20" },
  cancelado: { label: "Cancelado", next: null, className: "bg-red-500/15 text-red-400 border border-red-500/20" },
  recusado: { label: "Recusado", next: null, className: "bg-red-500/15 text-red-500 border border-red-500/20" },
  erro: { label: "Erro", next: null, className: "bg-red-500/15 text-red-500 border border-red-500/20" },
  disponivel: { label: "Disponível", next: null, className: "bg-emerald-500/15 text-emerald-500 border border-emerald-500/20" },
  em_antecipacao: { label: "Em Antecipação", next: null, className: "bg-blue-500/15 text-blue-500 border border-blue-500/20" },
};

export const StatusBadge = ({ status, showNext = false, className = "" }) => {
  const config = statusConfig[status] || { label: status, next: null, className: "bg-white/10 text-muted-foreground border border-white/10" };
  return (
    <div className={`inline-flex flex-col items-end ${className}`}>
      <span
        data-testid={`status-badge-${status}`}
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${config.className}`}
      >
        {config.label}
      </span>
      {showNext && config.next && (
        <span className="text-[10px] text-muted-foreground mt-0.5">{config.next}</span>
      )}
    </div>
  );
};
